<script generic="P, R" lang="ts" setup>
import type { CascaderOption, LoadingInstance, } from "element-plus"
import type { ApiCascaderProps, Props, } from "./types"
import type { CascaderInstance, } from "@/components/ElCascader"
import { cascaderEmits, ElLoading, } from "element-plus"
import { omit, } from "lodash-es"
import { ElCascader, } from "@/components/ElCascader"
import { basePropsKeys, defaultProps, } from "./types"
import { useOptions, } from "./useOptions"

const props = withDefaults(defineProps<ApiCascaderProps>(), {
  ...defaultProps,
  options: () => [],
  props: () => ({}),
  disabled: undefined,
  clearIcon: undefined,
  filterMethod: (node, keyword,) => {
    return node.text.toLowerCase().includes(keyword.toLowerCase(),)
  },
  separator: " / ",
  showAllLevels: true,
  maxCollapseTags: 1,
  debounce: 300,
  beforeFilter: () => true,
  placement: "bottom-start",
  fallbackPlacements: () => [
    "bottom-start",
    "bottom",
    "top-start",
    "top",
    "right",
    "left",
  ],
  teleported: true,
  effect: "light",
  tagType: "info",
  tagEffect: "light",
  validateEvent: true,
  persistent: true,
  showCheckedStrategy: "child",
  showPrefix: true,
  popperStyle: undefined,
  valueOnClear: undefined,
},)

const emits = defineEmits(cascaderEmits,)

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value,) {
    emits("update:modelValue", value,)
  },
},)

const { loading, formatOptions, fetchOptions, } = useOptions<P, R>(props as Props<P, R>,)

const componentRef = ref<CascaderInstance>()
const cascaderRef = computed(() => componentRef.value?.cascaderRef,)

// 过滤掉自定义的props，只保留EL组件需要的props
const bindProps = computed(() => {
  return omit(props, basePropsKeys, "modelValue", "options",)
},)

const loadingInstance = ref<LoadingInstance>()

watch(() => loading.value, (val,) => {
  if (val) {
    const target = cascaderRef.value?.$el.nextElementSibling
    loadingInstance.value = ElLoading.service({
      target,
      customClass: "api-select-loading-mask",
    },)
  } else {
    loadingInstance.value?.close()
  }
},)

defineExpose({
  fetchOptions,
  formatOptions,
  componentRef,
  cascaderRef,
},)
</script>

<template>
  <ElCascader
    ref="componentRef"
    v-model="modelValue"
    :options="formatOptions as CascaderOption[]"
    v-bind="bindProps"
    @blur="emits('blur', $event)"
    @change="emits('change', $event)"
    @clear="emits('clear')"
    @expand-change="emits('expandChange', $event)"
    @focus="emits('focus', $event)"
    @remove-tag="emits('removeTag', $event)"
    @visible-change="emits('visibleChange', $event)"
  >
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </ElCascader>
</template>

<style lang="scss">

</style>
